export default "__VITE_ASSET__CvgI4bb5__"